import { FC } from "react";
import Container from "react-bootstrap/Container";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import { Navigate } from "react-router-dom";
import { FaRedo } from "react-icons/fa";
import { useRouteParams } from "app/route/route";
import { resendReportInviteRoute, reportInvitesRoute } from "app/route/Routes";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { useResendReportInviteMutation, useReportInviteQuery } from "app/api/graph/types";
import { reportInviteGraphId } from "app/api/graph/helpers";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { formatISODateTime } from "app/util/format";
import { ErrorScreen } from "app/component/screen/ErrorScreen";
import { LoadingScreen } from "app/component/screen/LoadingScreen";

export const ResendReportInviteScreen: FC = () => {
    const { reportId, inviteId } = useRouteParams(resendReportInviteRoute);
    const { data, loading, error } = useReportInviteQuery({
        variables: { inviteId: reportInviteGraphId(inviteId) },
    });
    const [resendInvite, { data: resendData, loading: resending, error: resendError }] = useResendReportInviteMutation({
        variables: { input: { id: reportInviteGraphId(inviteId) } },
    });
    const invite = data?.reportInvite;

    if (loading) {
        return <LoadingScreen />;
    }
    if (error) {
        return <ErrorScreen title="Error" message={error.message} />;
    }
    if (!invite) {
        return <ErrorScreen title="Error" message="Not found." />;
    }
    if (invite.accepted) {
        return <ErrorScreen title="Error" message="This invite has already been accepted." />;
    }
    if (resendData?.resendReportInvite) {
        return <Navigate to={reportInvitesRoute.build({ reportId })} />;
    }

    return (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={resendReportInviteRoute} />
                <h1>Resend invite</h1>
                {resendError ? <Alert variant="danger">{resendError.message}</Alert> : null}
                <p>Are you sure that you want to resend this invite?</p>
                <Table responsive="sm">
                    <tbody>
                        <tr>
                            <th>First name</th>
                            <td>{invite.firstName ?? "-"}</td>
                        </tr>
                        <tr>
                            <th>Last name</th>
                            <td>{invite.lastName ?? "-"}</td>
                        </tr>
                        <tr>
                            <th>Email</th>
                            <td>{invite.email ?? "-"}</td>
                        </tr>
                        <tr>
                            <th>Invited at</th>
                            <td>{formatISODateTime(invite.createdAt)}</td>
                        </tr>
                    </tbody>
                </Table>
                <Button variant="warning" disabled={resending} onClick={() => resendInvite()}>
                    <FaRedo /> Resend
                </Button>
            </Container>
        </NavigationScreen>
    );
};
